// extracted by mini-css-extract-plugin
export default {"formIcons":"form-icons_formIcons__A-NcK"};